// discover-pack-tools-and-defaults.ts
//
// Quét pack/tools/ để biết tool nào CÓ SẴN + đọc danh sách tool init bật
// mặc định (tools/defaults.json). Đọc default từ pack (không hardcode trong CLI)
// → đổi default không cần release CLI mới.

import { promises as fs } from "node:fs";
import { join } from "node:path";
import { pathExists, readJson } from "./filesystem-helpers.js";
import { listEnabledTools } from "./tool-state-store.js";

const PACK_FEATURES_REL = [".claude", "pack", "tools"];

function packToolsDir(workspacePath: string): string {
  return join(workspacePath, ...PACK_FEATURES_REL);
}

// Liệt kê tool có manifest trong pack (mỗi dir con có tool.json).
export async function listAvailableTools(workspacePath: string): Promise<string[]> {
  const dir = packToolsDir(workspacePath);
  if (!(await pathExists(dir))) {
    return [];
  }
  const entries = await fs.readdir(dir, { withFileTypes: true });
  const names: string[] = [];
  for (const entry of entries) {
    if (!entry.isDirectory()) continue;
    if (await pathExists(join(dir, entry.name, "tool.json"))) {
      names.push(entry.name);
    }
  }
  return names.sort();
}

interface DefaultsFile {
  defaultTools?: string[];
}

// Đọc tools/defaults.json → danh sách tool init bật mặc định. Thiếu → [].
export async function readDefaultTools(workspacePath: string): Promise<string[]> {
  const path = join(packToolsDir(workspacePath), "defaults.json");
  if (!(await pathExists(path))) {
    return [];
  }
  try {
    const parsed = await readJson<DefaultsFile>(path);
    return parsed.defaultTools ?? [];
  } catch {
    return [];
  }
}

export interface ToolsOverview {
  available: string[]; // có manifest trong pack
  enabled: string[]; // enabled=true trong state
}

// Tổng hợp cho status/doctor: tool có sẵn (pack) + đang bật (state).
export async function discoverEnabledAndAvailableTools(
  workspacePath: string,
): Promise<ToolsOverview> {
  const [available, enabled] = await Promise.all([
    listAvailableTools(workspacePath),
    listEnabledTools(workspacePath),
  ]);
  return { available, enabled };
}
